/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FC, PropsWithChildren } from 'react';

import { RootState, useTivoSelector } from '../../../core/tivo/tivo-redux-wrapper';
import { ClockTypes } from '../../Clock';
import { AntiburnOsd, ScreenHeader } from '../../common';
import { Whisper } from '../../Whisper';

import '../SettingsCommon.scss';

interface SettingsTemplateProps {
    title: string;
}

const SettingsTemplate: FC<PropsWithChildren<SettingsTemplateProps>> = ({
    children,
    title,
}): JSX.Element => {
    const { isActive: isAntiburnOsdActive } = useTivoSelector(
        (state: RootState) => state.antiburnOsd,
    );
    return (
        <>
            <div className="settings-common-container">
                <ScreenHeader title={title.toUpperCase()} clockType={ClockTypes.DEFAULT_CLOCK} />
                {children}
            </div>
            <Whisper message="" />
            {isAntiburnOsdActive && <AntiburnOsd />}
        </>
    );
};

export default SettingsTemplate;
